import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { AssessmentDetails } from "Assessments";
import { LeDetails } from "LearningEngagement";
import ClassRoomDetails from "ClassRoom/routes/ClassRoomDetails";
import FlowSection from "../UnitFlowV2/routes/FlowSection";

export default store => ({
  path: "unitFlow",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "unit-planner-v3" */ "./components"),
        import(
          /* webpackChunkName: "unit-planner-v3" */ "./modules/UnitFlowModule"
        ),
        import(
          /* webpackChunkName: "unit-planner-v3" */ "OrganizationResources/modules/OrganizationResourcesModule"
        ),
        import(
          /* webpackChunkName: "unit-planner-v3" */ "AppComponents/EntityFlowComponents/ImportFromUnitFlowModal/modules/Module"
        ),
      ]).then(
        ([
          importedModule0,
          importedModule1,
          importedModule2,
          importedModule3,
        ]) => {
          const component = importedModule0.default;
          const reducer = importedModule1.default;
          const OrganizationResourcesReducer = importedModule2.default;

          injectReducer(store, {
            key: "organizationResource",
            reducer: OrganizationResourcesReducer,
          });
          injectReducer(store, {
            key: "unitFlow",
            reducer,
          });

          const importFromUnitFlowModalReducer = importedModule3.default;
          injectReducer(store, {
            key: "importFromUnitFlow",
            reducer: importFromUnitFlowModalReducer,
          });

          return component;
        }
      )
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    LeDetails(store),
    AssessmentDetails(store),
    FlowSection(store),
    ClassRoomDetails(store),
  ],
});
